import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to fetch recipes based on user's pantry ingredients
 * Returns an array of objects, each containing:
 * - ingredient_id: The ID of the pantry ingredient
 * - ingredient_name: The name of the ingredient
 * - recipes: Array of recipes that use this ingredient
 */
export const usePantryRecipes = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pantryRecipes, setPantryRecipes] = useState([]);
    const { sessionToken } = useAuth();

    const fetchPantryRecipes = useCallback(async () => {
        if (!sessionToken) {
            setError('No session token provided');
            setPantryRecipes([]);
            return [];
        }

        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch('/api/v1/recipe/pantry', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${sessionToken}`
                }
            });

            console.log('fetchPantryRecipes status:', response.status);

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || errorData.message || 'Failed to fetch pantry recipes');
            }

            const data = await response.json();
            console.log('fetchPantryRecipes data:', data);

            if (Array.isArray(data)) {
                setPantryRecipes(data);
                return data;
            } else {
                console.error('Invalid data format:', data);
                setPantryRecipes([]);
                return [];
            }
        } catch (err) {
            console.error('Error fetching pantry recipes:', err);
            setError(err.message);
            setPantryRecipes([]);
            return [];
        } finally {
            setIsLoading(false);
        }
    }, [sessionToken]);

    return {
        fetchPantryRecipes,
        pantryRecipes,
        isLoading,
        error
    };
};

